import React from 'react';
import AuthService from './authService';
import TpClientLinkItem from '../Domain/TpClientLinkItem';
import SearchParams from '../Elements/SearchParams';
import TpClientLinkSearchParams from '../Contents/ThirdParty/TpClientLink/TpClientLinkSearchParams';

export default class TpClientLinkService extends React.Component {
  static UnlinkApproved(clientId, tpClientLinkId) {
    const authService = AuthService.getInstance();
    const url = '/api/TpClientLink/UnlinkClient';
    const data = {
      clientId,
      tpClientLinkId,
    };
    const dataJson = JSON.stringify(data);

    return authService.CallBackendFunctionPut(url, dataJson);
  }

  static GetTpClientLinkItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpClientLinkSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/TpClientLink/GetItems?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static LinkTpClient(tpClientLinkData) {
    const url = `/api/TpClientLink/LinkTpClient`;
    const dataJson = JSON.stringify(tpClientLinkData);
    return AuthService.getInstance().CallBackendFunctionPost(url, dataJson);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpClientLinkItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
